<template>
  <button class="flex"><i class="material-icons">chevron_right</i></button>
</template>

<script>
export default {
  name: 'DatatablesFieldsNavField',
}
</script>
